import { render, staticRenderFns } from "./RightSidebar.vue?vue&type=template&id=b0638358&"
import script from "./RightSidebar.vue?vue&type=script&lang=js&"
export * from "./RightSidebar.vue?vue&type=script&lang=js&"
import style0 from "./RightSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports